/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_CommandInputs */

const en_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network Command`)
};

const es_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mando de red`)
};

const fr_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande réseau`)
};

const de_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netzwerk-Kommando`)
};

const ja_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワークコマンド`)
};

const zh_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网络指挥`)
};

const ar_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوامر الشبكة`)
};

const id_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komando Jaringan`)
};

const it_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando di Rete`)
};

const ru_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сетевое управление`)
};

const pt_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando de Rede`)
};

const ko_network_command = /** @type {(inputs: Network_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네트워크 커맨드`)
};

/**
* | output |
* | --- |
* | "Network Command" |
*
* @param {Network_CommandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const network_command = /** @type {((inputs?: Network_CommandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_CommandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_network_command(inputs)
	if (locale === "es") return es_network_command(inputs)
	if (locale === "fr") return fr_network_command(inputs)
	if (locale === "de") return de_network_command(inputs)
	if (locale === "ja") return ja_network_command(inputs)
	if (locale === "zh") return zh_network_command(inputs)
	if (locale === "ar") return ar_network_command(inputs)
	if (locale === "id") return id_network_command(inputs)
	if (locale === "it") return it_network_command(inputs)
	if (locale === "ru") return ru_network_command(inputs)
	if (locale === "pt") return pt_network_command(inputs)
	return ko_network_command(inputs)
});